<template><div>

	<ImageZoom :src="currentImage.url" class="w-100 h-100" :title="title" />

	<ol v-if="images.length > 1" class="thumbnails">
		<li v-for="(image, index) in images" :key="index">
			<img
				class="thumbnail"
				:class="{ selected: index === currentSelection }"
				:src="image.url"
				@click="currentSelection = index"
				:alt="title"
			>
		</li>
	</ol>

</div></template>

<script>

	import ImageZoom from '@component/UI/ImageZoom';

	export default {
		props: {
			images: Array,
			title: String
		},

		components: {
			ImageZoom
		},

		data() {
			return {
				currentSelection: 0
			}
		},

		computed: {
			currentImage() {
				return this.images[this.currentSelection];
			}
		}
	}

</script>

<style lang="scss" scoped>

	.thumbnails {
		display: flex;
		flex-wrap: wrap;
		list-style: none;
        align-items: center;
		padding: 0;
		margin: 0;
		margin-top: 20px;
	}

	.thumbnail {
		opacity: 0.5;
		width: 65px;
		// height: 65px;
		cursor: pointer;
	}

	.selected {
		opacity: 1;
	}

	.thumbnail:hover {
		opacity: 1;
	}

</style>
